// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import Modal from '../common/modal';

import LoadingIndicator from '../ui/loading-indicator.js';
import { MODAL_EDIT_CREDIT, MODAL_CREDIT } from './transaction.const.js';
import { transactionsSelector } from './transaction.selectors.js';
import { addCredit, saveCredit } from './transaction.actions.js';
import { selectUIModal, selectUIProgress } from '../ui/ui.helpers.js';
import { setModal } from '../ui/ui.actions.js';
import { amountPattern } from '../payments/payments.const.js';

const typeToModal = {
  add: {
    modal: MODAL_CREDIT,
    text: 'Add credit'
  },
  edit: {
    modal: MODAL_EDIT_CREDIT,
    text: 'Save credit'
  }
};

class TransactionCreditModifyModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: ''
    };

    this.closeModal = this.props.setModal.bind(this, false, typeToModal[props.type].modal);
    this.onCreditAmountChange = this.onCreditAmountChange.bind(this);
    this.onSubmitCredit = this.onSubmitCredit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const transaction = nextProps.transactions[nextProps.transactionId];
    this.setState({
      amount: transaction ? transaction.amount : ''
    });
  }

  onCreditAmountChange: Function;
  onCreditAmountChange(e) {
    return this.setState({ amount: e.currentTarget.value });
  }

  onSubmit: Function;
  onSubmitCredit(e) {
    e.preventDefault();
    return this.props.type === 'add'
      ? this.props.addCredit(this.state)
      : this.props.saveCredit({ ...this.state, id: this.props.transactionId });
  }

  render() {
    const { type, progress, creditModal } = this.props;

    return (
      <Modal isOpen={creditModal} onClose={this.closeModal} header={typeToModal[type].text}>
        <form onSubmit={this.onSubmitCredit}>
          <input
            type="text"
            pattern={amountPattern}
            className="form-control"
            value={this.state.amount}
            onChange={this.onCreditAmountChange}
            disabled={progress}
            required
          />
          <p>Please enter the credit amount</p>
          <button
            type="submit"
            disabled={progress}
            className="btn btn-xs btn-success btn-modal-credit"
          >
            {typeToModal[type].text}
          </button>

          {progress ? <LoadingIndicator /> : null}
        </form>
      </Modal>
    );
  }
}

const progressSelector = selectUIProgress();

const mapStateToProps = (state, props) => {
  const modalSelector = selectUIModal(typeToModal[props.type].modal);
  return {
    creditModal: modalSelector(state),
    progress: progressSelector(state),
    transactions: transactionsSelector(state)
  };
};

export default connect(
  mapStateToProps,
  {
    setModal,
    saveCredit,
    addCredit
  }
)(TransactionCreditModifyModal);
